import React, { useEffect, useContext, useState } from 'react';
import { AppContext } from '../../context/AppContext';
import axios from 'axios';
import profileDefault from '../../images/profile.gif';
import '../../css/ProfileDetail.css';

const ProfileDetails = ({ handleSelection }) => {


    const { loggedIN, user, isAuthenticated } = useContext(AppContext);
    const [profileData, setProfileData] = useState({
        name: user?.data?.name || '',
        email: user?.data?.email || '',
    });
    const [selectedSection, setSelectedSection] = useState('');

    // Fetch Bearer token (Assuming it's stored in localStorage)
    const token = localStorage.getItem('authToken');

    // Handle input changes dynamically
    const handleChange = (e) => {
        const { name, value, files } = e.target;

        if (name === 'image' && files.length > 0) {
            // Handle the image upload separately
            const file = files[0]; // Get the first selected file
            setProfileData((prevData) => ({
                ...prevData,
                [name]: file, // Store the file object in the state
            }));
        } else {
            // Handle regular text inputs
            setProfileData((prevData) => ({
                ...prevData,
                [name]: value, // Update other fields with regular text values
            }));
        }
    };


    const saveChanges = async () => {
        try {
            const formData = new FormData();

            // Append the profile data to the FormData
            Object.keys(profileData).forEach((key) => {
                formData.append(key, profileData[key]);
            });

            // Example API call to save the profile data including the image
            const response = await axios.post(
                `${process.env.REACT_APP_BASE_URL}/editProfile`, // Replace with your API URL
                formData,
                {
                    headers: {
                        Authorization: `Bearer ${token}`, // Attach Bearer token
                        'Content-Type': 'multipart/form-data', // Set correct content type for file upload
                    },
                }
            );

            if (response.status) {
                // alert('Profile Updated Successfully');

                loggedIN(token, response.data)
            }
        } catch (error) {
            console.error('Error updating profile:', error);
            alert('Failed to update profile. Please try again.');
        }
    };

    //alert(user?.data?.auth_provider);
    //alert(user?.data?.image)

    return (

        <div >
            <div className='d-flex justify-content-between'>
                <div className='title-header-filter breadcrumb'>
                    <div className='profile-path'>
                        <span>Profile Details</span>
                    </div>
                </div>
                <div className=" border-bottom-0">
                    <span onClick={() => handleSelection('profileEdit')} className='text-decoration none btn profile-edit'>

                        <svg width="16" height="17" viewBox="0 0 16 17" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill-rule="evenodd" clip-rule="evenodd" d="M14.081 2.75278C13.3 1.97173 12.0337 1.97173 11.2526 2.75278L10.1328 3.87265L4.86209 9.14328C4.77665 9.22875 4.71604 9.33581 4.68674 9.45301L4.02007 12.1197C3.96327 12.3469 4.02984 12.5872 4.19542 12.7527C4.36101 12.9183 4.60134 12.9849 4.82852 12.9281L7.49516 12.2615C7.61243 12.2321 7.71943 12.1715 7.80489 12.0861L13.0372 6.85379L14.1954 5.69559C14.9765 4.91454 14.9765 3.64821 14.1954 2.86716L14.081 2.75278ZM12.1954 3.69559C12.4558 3.43524 12.8779 3.43524 13.1382 3.69559L13.2526 3.80997C13.513 4.07032 13.513 4.49243 13.2526 4.75278L12.575 5.43046L11.538 4.353L12.1954 3.69559ZM10.595 5.29598L11.632 6.37344L6.9927 11.0127L5.58308 11.3651L5.93547 9.95555L10.595 5.29598ZM2.66683 6.28137C2.66683 5.91319 2.96531 5.61471 3.3335 5.61471H6.66683C7.03503 5.61471 7.3335 5.31623 7.3335 4.94804C7.3335 4.57985 7.03503 4.28137 6.66683 4.28137H3.3335C2.22893 4.28137 1.3335 5.17681 1.3335 6.28137V13.6147C1.3335 14.7193 2.22893 15.6147 3.3335 15.6147H10.6668C11.7714 15.6147 12.6668 14.7193 12.6668 13.6147V10.2813C12.6668 9.91321 12.3684 9.61468 12.0002 9.61468C11.632 9.61468 11.3335 9.91321 11.3335 10.2813V13.6147C11.3335 13.9829 11.035 14.2813 10.6668 14.2813H3.3335C2.96531 14.2813 2.66683 13.9829 2.66683 13.6147V6.28137Z" fill="white" />
                        </svg>

                        Edit Details

                    </span>
                </div>
            </div>
            <div className='main-area'>
                <div className='mid-profile-img'>



                    <img className='img-fluid' src={process.env.REACT_APP_IMAGE_PATH_2 + "user/" + user?.data?.image} alt="DreamSakha" onError={(e) => { e.target.onerror = null; e.target.src = profileDefault; }} />

                </div>
                <div className='w-100 pt-3'>
                    <div className='profile-descrption'>
                        <p className='profile-description-key'>Name</p>
                        <p className='profile-description-data'>{user?.data?.name || ''}</p>
                    </div>
                    <div className='profile-descrption'>
                        <p className='profile-description-key'>Email Address</p>
                        <p className='profile-description-data'>{user?.data?.email || ''}</p>
                    </div>
                    <div className='profile-descrption'>
                        <p className='profile-description-key'>Phone No.</p>
                        <p className='profile-description-data'>{user?.data?.mobile || ''}</p>
                    </div>
                    <div className='profile-descrption-last'>
                        <p className='profile-description-key'>Registered As</p>
                        <p className='profile-description-data'> {user?.data?.role_name || ''}</p>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default ProfileDetails
